<template>
  <el-dialog
    title="История изменений"
    width="800px"
    style="border-radius: 10px"
    :center="true"
    :model-value="visible"
    :before-close="handleCloseDialog"
  >
    <div class="changelogs">
      <div class="changelogs__body" v-html="logs"></div>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios';
import { marked } from 'marked';

export default {
  name: 'ChangeLogs',

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },

  emits: ['close-dialog'],

  data() {
    return {
      logs: '',
    };
  },

  async mounted() {
    let response = await axios.get('/api/changelog');
    marked.use({
      renderer: {
        heading({ tokens, depth }) {
          const text = this.parser.parseInline(tokens);
          return `<h${depth} class="changelogs__header">${text}</h${depth}>`;
        },
        list(tokens) {
          return `<ul class="changelogs__list">${this.listitem(tokens.items)}</ul>`;
        },
        listitem(tokens) {
          let text = '';
          for (let token of tokens) {
            text += `<li class="changelogs__list__item">${this.parser.parseInline(token.tokens)}</li>`;
          }

          return text;
        },
      },
    });
    this.logs = marked.parse(response.data);
  },

  methods: {
    handleCloseDialog() {
      this.$emit('close-dialog');
    },
  },
};
</script>
